import moment from 'moment';
import * as React from 'react';
import { Input, InputGroup } from 'reactstrap';
import {
  GET_VALID_TIME_INPUT_STATE,
  getValidTime,
  mergeClasses,
} from '../constants';
import { InputState } from '../types';
import ClearFieldButton from './ClearFieldButton';

type Props = {
  className?: string;
  time: InputState;
  max?: moment.Moment | null;
  onChange: (arg0: InputState) => void;
  resetState: InputState;
};

export default class TimeInput extends React.Component<Props> {
  onChange = (event: React.SyntheticEvent<HTMLInputElement>) =>
    this.props.onChange({ value: event.currentTarget.value, isValid: true });

  onBlur = (event: React.SyntheticEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;
    this.validatedOnChange(value);
  };

  onReset = () => {
    const { resetState } = this.props;
    this.validatedOnChange(resetState.value);
  };

  validatedOnChange = (value: string) => {
    const { onChange, max } = this.props;
    let time = getValidTime(value);
    if (time) {
      // if 'max' is set, return the smaller of 'max' or the current time
      if (max && max.isBefore(time)) {
        time = max;
      }
      onChange(GET_VALID_TIME_INPUT_STATE(time));
    } else {
      onChange({ value, isValid: false });
    }
  };

  render() {
    const { time, className } = this.props;
    return (
      <InputGroup className={time.isValid ? undefined : 'is-invalid'}>
        <Input
          className={mergeClasses(['no-bg-img', className])}
          style={{ maxWidth: '5em' }}
          invalid={!time.isValid}
          onBlur={this.onBlur}
          onChange={this.onChange}
          placeholder={'hh:mm'}
          value={time.value}
        />
        <ClearFieldButton onClick={this.onReset} />
      </InputGroup>
    );
  }
}
